import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Clock, MapPin } from 'lucide-react';

export const ExpandableCard = ({ title, summary, details, children, type }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const formatScheduleDetails = (details) => {
    if (type === 'when' && details) {
      return (
        <div className="schedule-details">
          <h4 className="schedule-title">🎉 Déroulé de la journée :</h4>
          <div className="schedule-list">
            {details.map((detail, index) => (
              <div key={index} className="schedule-item">
                <Clock size={16} className="schedule-icon" />
                <span className="schedule-text">{detail}</span>
              </div>
            ))}
          </div>
        </div>
      );
    }
    return (
      <div className="expandable-card-details">
        {details.map((detail, index) => (
          <p key={index} className="expandable-card-detail">{detail}</p>
        ))}
      </div>
    );
  };

  return (
    <div className={`expandable-card ${isExpanded ? 'expanded' : ''}`}>
      <div className="expandable-card-header">
        <h3 className="expandable-card-title">{title}</h3>
        <p className="expandable-card-summary">{summary}</p>
      </div>
      
      {isExpanded && (
        <div className="expandable-card-content">
          {details && formatScheduleDetails(details)}
          {children}
        </div>
      )}
      
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="expandable-card-toggle"
      >
        <span className="mr-1">
          {isExpanded ? 'Réduire' : 'Plus de détails'}
        </span>
        {isExpanded ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
      </button>
    </div>
  );
};